import React from "react";

import styles from "../../../../styles/integrations.module.scss";

import { EnvironmentStorage } from "../../../tools/EnvironmentStorage";
import { Loading } from "../../../components/Loading";
import { Drawer } from "../../../components/Drawer";
import { Input } from "../../../components/Input";
import { Button } from "../../../components/Button";
import { Context } from "pages/Integrations";
import { EnvironmentsAPI } from "providers/EnvironmentsAPI";
import { Toggle } from "shared/components/Toggle";
import { Message, Select } from "@components";
import { IntegrationsAPI } from "providers/IntegrationsAPI";

const Statuses = {
  IN_PRODUCTION: {
    key: "IN_PRODUCTION",
    name: "Em produção",
  },
  ON_DELIVERY: {
    key: "ON_DELIVERY",
    name: "Saiu para entrega",
  },
  FINISHED: {
    key: "FINISHED",
    name: "Finalizado",
  },
  CANCELED: {
    key: "CANCELED",
    name: "Cancelado",
  },
};

export default class BlingStatusesDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      loading: false,
      step: null,
      account: null,
    };

    this.timer = null;
    this.window = null;
    this.listener = null;
    this.windowChecker = null;
  }

  componentDidMount() {
    this.loadConfigs();
  }

  componentWillUnmount() {}

  async loadConfigs() {
    try {
      const environmentId = EnvironmentStorage.getEnvironment().id;

      const statusesResponse = await IntegrationsAPI.getBlingStatuses(
        environmentId
      );
      const statuses = statusesResponse.getData([]);

      const configurationsResponse = await IntegrationsAPI.getBlingConfigurations(environmentId);
      const configurations = configurationsResponse.getData([]);

      this.setState({
        loadingPage: false,
        statuses,
        configurations,
      });
    } catch (err) {
      console.log(err);
    }
  }

  async onSave() {
    try {
      const { onSave } = this.props;
      const { configurations } = this.state;

      this.setState({ loading: true });

      const environmentId = EnvironmentStorage.getEnvironment().id;

      const updateResponse = await IntegrationsAPI.upsertBlingConfigurations(environmentId, configurations);

      this.setState({ loading: false });

      if (updateResponse.getErrors([]).length === 0) {
        onSave && onSave();
      } else {
        alert({
          text: `Não foi possível alterar a configuração: ${
            updateResponse.getErrors()[0]
          }`,
        });
      }
    } catch (e) {
      this.setState({ loading: false });
    }
  }

  buildSelectOptions(options, selectedValue) {
    const builtOptions = options.map((option) => ({
      label: option.name,
      value: option.id,
      selected: option.id === selectedValue,
    }));

    return [
      {
        label: "Selecione",
        value: null,
        selected: !selectedValue,
      },
      ...builtOptions,
    ];
  }

  render() {
    const { loading, loadingPage } = this.state;
    const { visible, onClose } = this.props;

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        title={"Bling - Situações"}
        footer={
          <Button
            design="primary"
            className="w-100"
            onClick={() => this.onSave()}
            loading={loading}
            disabled={loading}
          >
            Salvar
          </Button>
        }
      >
        <Context />

        {loadingPage ? (
          <div className="d-flex justify-center align-center h-100">
            <Loading fullScreen />
          </div>
        ) : (
          <div className={styles.scrollContainer}>
            {Object.values(Statuses).map((status) => (
              <Select
                design="two"
                label={`Situação - ${status.name}`}
                onChange={(e) =>
                  this.setState({
                    configurations: {
                      ...this.state.configurations,
                      statuses: {
                        ...this.state.configurations.statuses,
                        [status.key]: e.target.value || null,
                      }
                    },
                  })
                }
                className="mb-20"
                value={this.state.configurations?.statuses?.[status.key]}
                options={this.buildSelectOptions(
                  this.state.statuses,
                  this.state.configurations?.statuses?.[status.key]
                )}
              />
            ))}
          </div>
        )}
      </Drawer>
    );
  }
}
